import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import "@pocketsign/design-system/styles.scoped.css";
import "./index.css";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";
import "./libs/i18n";
import { getTenantSlug } from "./libs/utils";
// Import the generated route tree
import { routeTree } from "./routeTree.gen";

import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

// Create a new router instance
const router = createRouter({
  routeTree,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
// biome-ignore lint/style/noNonNullAssertion: <explanation>
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
      { import.meta.env.DEV && <TanStackRouterDevtools router={router} />}
    </StrictMode>,
  );
}

function getSentryEnv() {
  const slug = getTenantSlug();
  const appEnv = import.meta.env.VITE_APP_ENV;
  return `${slug}-${appEnv}`;
}

if (import.meta.env.VITE_ENABLE_SENTRY === "true") {
  Sentry.init({
    dsn: "https://b4132ca7d46468ee98c363a0f72a190e@o4504292631707648.ingest.sentry.io/4505941764210688",
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],

    // パフォーマンスの計測は行わない
    tracesSampleRate: 0,
    // エラーのないセッションでのリプレイは不要なので無効化
    replaysSessionSampleRate: 0,
    // すべてのエラーで replay を有効にする
    replaysOnErrorSampleRate: 1.0,

    // 通信環境起因のエラーは通知しない
    ignoreErrors: [
      "Failed to fetch",
      "Load failed",
      "NetworkError when attempting to fetch resource",
      "The Internet connection appears to be offline",
    ],

    environment: getSentryEnv(),
  });
}
